import { render, staticRenderFns } from "./creatTask.vue?vue&type=template&id=d6f3c9d6&scoped=true&"
import script from "./creatTask.vue?vue&type=script&lang=js&"
export * from "./creatTask.vue?vue&type=script&lang=js&"
import style0 from "./creatTask.vue?vue&type=style&index=0&id=d6f3c9d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f3c9d6",
  null
  
)

export default component.exports